import TRANSLATION from "./translations";
import session from "./session";
import CONFIG_COMPANY from "./myConfig";

export default class Loc {

    getDefaultLanguage(){
        if(CONFIG_COMPANY.DEFAULT_LANGUAGE == null) return "sr"
        return CONFIG_COMPANY.DEFAULT_LANGUAGE;
    }

    getLanguage() {
        let loc = session.getLocale()
        switch (loc){
            case "en": return TRANSLATION.EN
            case "sr": return TRANSLATION.SR
            case "ar": return TRANSLATION.AR
            default: return TRANSLATION.EN
        }
    }

    getCompanyLanguage(){
        let companyConfig = CONFIG_COMPANY.CUSTOM_LOCALIZATION
        let loc = session.getLocale()
        switch (loc){
            case "en": return companyConfig.EN
            case "sr": return companyConfig.SR
            default: return companyConfig.EN
        }
    }

    t(key){
        let companyTranslate = this.getCompanyLanguage()[key]
        // Some company localizations return raw key string when key is missing.
        // In that case, fall back to global translations instead of showing raw key.
        if(companyTranslate != null && companyTranslate !== key) return companyTranslate

        let value = this.getLanguage()[key]
        return value == null ? key : value
    }
}



// WEBPACK FOOTER //
// ./src/services/localization.js